require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPropsToStyleNames = exports.Accordion = exports.VueNativeBase = exports.SwipeRow = exports.Root = exports.Segment = exports.DefaultTabBar = exports.TabContainer = exports.TabHeading = exports.ActionSheet = exports.ScrollableTab = exports.Toast = exports.View = exports.TabContent = exports.Text = exports.Grid = exports.Row = exports.Col = exports.Textarea = exports.Label = exports.Subtitle = exports.Item = exports.DeckSwiper = exports.Separator = exports.ListItem = exports.List = exports.Picker = exports.FooterTab = exports.Tabs = exports.Tab = exports.Footer = exports.Content = exports.Container = exports.Switch = exports.Spinner = exports.H3 = exports.H2 = exports.H1 = exports.CardItem = exports.Card = exports.Thumbnail = exports.Radio = exports.CheckBox = exports.Badge = exports.Body = exports.Right = exports.Left = exports.Fab = exports.Title = exports.Input = exports.InputGroup = exports.Form = exports.Header = exports.Icon = exports.IconNB = exports.DatePicker = exports.Button = exports.Drawer = exports.connectStyle = exports.StyleProvider = exports.variables = exports.getTheme = undefined;

var _nativeBaseShoutemTheme = require('native-base-shoutem-theme');

var _lodash = require('lodash');

var _reactNativeEasyGrid = require('react-native-easy-grid');

var _init = require("./init");

var _init2 = _interopRequireDefault(_init);

var _components = require("./theme/components");

var _components2 = _interopRequireDefault(_components);

var _platform = require("./theme/variables/platform");

var _platform2 = _interopRequireDefault(_platform);

var _Drawer = require("./basic/Drawer");

var _Drawer2 = _interopRequireDefault(_Drawer);

var _SwipeRow = require("./basic/SwipeRow");

var _Text = require("./basic/Text");

var _View = require("./basic/View");

var _Button = require("./basic/Button");

var _DatePicker = require("./basic/DatePicker");

var _TabHeading = require("./basic/TabHeading");

var _TabContainer = require("./basic/TabContainer");

var _IconNB = require("./basic/IconNB");

var _Icon = require("./basic/Icon");

var _Header = require("./basic/Header");

var _InputGroup = require("./basic/InputGroup");

var _Input = require("./basic/Input");

var _Title = require("./basic/Title");

var _Fab = require("./basic/Fab");

var _Left = require("./basic/Left");

var _Right = require("./basic/Right");

var _Body = require("./basic/Body");

var _Badge = require("./basic/Badge");

var _Checkbox = require("./basic/Checkbox");

var _Radio = require("./basic/Radio");

var _Thumbnail = require("./basic/Thumbnail");

var _Card = require("./basic/Card");

var _CardItem = require("./basic/CardItem");

var _H = require("./basic/H1");

var _H2 = require("./basic/H2");

var _H3 = require("./basic/H3");

var _Spinner = require("./basic/Spinner");

var _Switch = require("./basic/Switch");

var _Container = require("./basic/Container");

var _Root = require("./basic/Root");

var _Content = require("./basic/Content");

var _Footer = require("./basic/Footer");

var _FooterTab = require("./basic/FooterTab");

var _Form = require("./basic/Form");

var _ToastContainer = require("./basic/ToastContainer");

var _Actionsheet = require("./basic/Actionsheet");

var _Picker = require("./basic/Picker");

var _List = require("./basic/List");

var _ListItem = require("./basic/ListItem");

var _Separator = require("./basic/Separator");

var _DeckSwiper = require("./basic/DeckSwiper");

var _Item = require("./basic/Item");

var _Segment = require("./basic/Segment");

var _Label = require("./basic/Label");

var _Textarea = require("./basic/Textarea");

var _Tab = require("./basic/Tab");

var _Tabs = require("./basic/Tabs");

var _Tabs2 = _interopRequireDefault(_Tabs);

var _DefaultTabBar = require("./basic/Tabs/DefaultTabBar");

var _ScrollableTabBar = require("./basic/Tabs/ScrollableTabBar");

var _Subtitle = require("./basic/Subtitle");

var _Accordion = require("./basic/Accordion");

var _vueNative = require("./vue-native.js");

var _vueNative2 = _interopRequireDefault(_vueNative);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

(0, _init2["default"])();
exports.getTheme = _components2["default"];
exports.variables = _platform2["default"];
exports.StyleProvider = _nativeBaseShoutemTheme.StyleProvider;
exports.connectStyle = _nativeBaseShoutemTheme.connectStyle;
exports.Drawer = _Drawer2["default"];
exports.Button = _Button.Button;
exports.DatePicker = _DatePicker.DatePicker;
exports.IconNB = _IconNB.IconNB;
exports.Icon = _Icon.Icon;
exports.Header = _Header.Header;
exports.Form = _Form.Form;
exports.InputGroup = _InputGroup.InputGroup;
exports.Input = _Input.Input;
exports.Title = _Title.Title;
exports.Fab = _Fab.Fab;
exports.Left = _Left.Left;
exports.Right = _Right.Right;
exports.Body = _Body.Body;
exports.Badge = _Badge.Badge;
exports.CheckBox = _Checkbox.CheckBox;
exports.Radio = _Radio.Radio;
exports.Thumbnail = _Thumbnail.Thumbnail;
exports.Card = _Card.Card;
exports.CardItem = _CardItem.CardItem;
exports.H1 = _H.H1;
exports.H2 = _H2.H2;
exports.H3 = _H3.H3;
exports.Spinner = _Spinner.Spinner;
exports.Switch = _Switch.Switch;
exports.Container = _Container.Container;
exports.Content = _Content.Content;
exports.Footer = _Footer.Footer;
exports.Tab = _Tab.Tab;
exports.Tabs = _Tabs2["default"];
exports.FooterTab = _FooterTab.FooterTab;
exports.Picker = _Picker.PickerNB;
exports.List = _List.List;
exports.ListItem = _ListItem.ListItem;
exports.Separator = _Separator.Separator;
exports.DeckSwiper = _DeckSwiper.DeckSwiper;
exports.Item = _Item.Item;
exports.Subtitle = _Subtitle.Subtitle;
exports.Label = _Label.Label;
exports.Textarea = _Textarea.Textarea;
exports.Col = _reactNativeEasyGrid.Col;
exports.Row = _reactNativeEasyGrid.Row;
exports.Grid = _reactNativeEasyGrid.Grid;
exports.Text = _Text.Text;
exports.TabContent = _Content.Content;
exports.View = _View.ViewNB;
exports.Toast = _ToastContainer.ToastContainer;
exports.ScrollableTab = _ScrollableTabBar.ScrollableTab;
exports.ActionSheet = _Actionsheet.ActionSheetContainer;
exports.TabHeading = _TabHeading.TabHeading;
exports.TabContainer = _TabContainer.TabContainer;
exports.DefaultTabBar = _DefaultTabBar.DefaultTabBar;
exports.Segment = _Segment.Segment;
exports.Root = _Root.Root;
exports.SwipeRow = _SwipeRow.SwipeRow;
exports.VueNativeBase = _vueNative2["default"];
exports.Accordion = _Accordion.Accordion;

var mapPropsToStyleNames = function mapPropsToStyleNames(styleNames, props) {
  return (0, _lodash.keys)(props);
};

exports.mapPropsToStyleNames = mapPropsToStyleNames;